module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (145).610c0013.jpg";